module.exports = __webpack_public_path__ + "img/duplicate.8a2c9eb9.svg";